<template>
	<div class="teacher_component">
		<div class="teacher_header flex bg_white teacher_header2">
			<div class="teacher_header_l flex">
				<img :src="public.top_logo" />
				<span class="f20px">·&nbsp;&nbsp;&nbsp;&nbsp;{{logo_name}}</span>
			</div>
			<div class="teacher_header_r tc f16px flex">
				<router-link to="/class_manage" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回教师首页</p>
				</router-link>
				<div class="logon_header_list cl_dark cur" @click="signOut">
					<img src="../../static/icon_sign.png" />
					<p>退出登录</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'teacher_header',
	  props: {
	    logo_name: "",
	  },
		data () {
			return {
				myInfo: {},
				public: {},
			}
		},
		mounted() {
			this.getMyInfo();
			this.getInfo();
		},
		methods: {
			//个人信息
			getMyInfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
					that.$emit("info-event", that.myInfo)
				});
			},
			//基础信息
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data;
					that.$emit("public-event", that.public)
				});
			},
			//退出
			signOut () {
				localStorage.removeItem("token");
				this.$router.push({path:'/'})
			},
		},
	}
</script>

<style>
</style>
